import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';

import { EpComboBoxComponent, IEpComboBoxModel, IEpComboColumns, EpTextAlign, IEpComponentModel } from '@epicor/kinetic';
import { DocumentTypes, MainMenu, Right } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { EpbtFaDocumentService } from '../../services/epbt-fa-document.service';


@Component({
  selector: 'epbt-fa-documenttype-list',
  templateUrl: './epbt-fa-documenttype-list.component.html',
  styleUrls: ['./epbt-fa-documenttype-list.component.scss']
})
export class EpbtFaDocumenttypeListComponent implements OnInit {
  documentTypes: any;

  private _selectedDocumenttypeId: string;
  @Input('selectedDocumenttypeId') set selectedDocumenttypeId(value: string) {
    this._selectedDocumenttypeId = value;
    this.selectedDocumenttypeIdChange.emit(this._selectedDocumenttypeId);
  }
  get selectedDocumenttypeId(): string {
    return this._selectedDocumenttypeId;
  }
  @Input() fromDashbard: boolean = false;
  @Output() selectedDocumenttypeIdChange = new EventEmitter<any>();

  constructor(private fieldAgentService: EpbtFieldAgentService, private docService: EpbtFaDocumentService) { }

  ngOnInit(): void {
    this.fieldAgentService.getWebTrackUser((webtrackUser: any) => {
      this.fieldAgentService.getBisTrackSetting((bisTrackSetting: any) => {
        this.documentTypes = [];
        if (!this.fromDashbard) {
          this.documentTypes = [
            {
              name: 'Opportunities',
              key: DocumentTypes.Opportunities,
              visible: bisTrackSetting && bisTrackSetting.licensing.crmEnabled && this.checkDocPermissions(webtrackUser, Right.ViewOpportunities)
            }
          ];
        }

        this.documentTypes.push(
          {
            name: 'Quotes',
            key: DocumentTypes.Quotes,
            visible: this.checkDocPermissions(webtrackUser, Right.ViewQuotes)
          },
          {
            name: 'Orders',
            key: DocumentTypes.Orders,
            visible: this.checkDocPermissions(webtrackUser, Right.ViewOrders)
          },
          {
            name: 'Template Orders',
            key: DocumentTypes.TemplateOrders,
            visible: this.checkDocPermissions(webtrackUser, Right.ViewTemplateOrders)
          },
          {
            name: 'Call Off Orders',
            key: DocumentTypes.CallOffOrders,
            visible: this.checkDocPermissions(webtrackUser, Right.ViewCallOffOrders)
          },
          {
            name: 'Invoices',
            key: DocumentTypes.Invoices,
            visible: this.checkDocPermissions(webtrackUser, Right.ViewInvoices)
          },
          {
            name: 'Credits',
            key: DocumentTypes.Credits,
            visible: this.checkDocPermissions(webtrackUser, Right.ViewCreditNotes)
          },
          {
            name: 'Statements',
            key: DocumentTypes.Statements,
            visible: this.checkDocPermissions(webtrackUser, Right.ViewStatements)
          }
        );
        if (this.fromDashbard) {
          this.documentTypes.push({
            name: 'Stock Transfers',
            key: DocumentTypes.Stocktransfers,
            visible: this.checkDocPermissions(webtrackUser, Right.ViewStock)
          },
            {
              name: 'Purchase Orders',
              key: DocumentTypes.PurchaseOrder,
              visible: true
            },
            {
              name: 'Work Orders',
              key: DocumentTypes.WorkOrders,
              visible: true
            }
          );
        }
        this.documentTypes = this.documentTypes.filter(item => item.visible);
        let key = this.fromDashbard && this.docService.selectedDocumentTypeForDash ? this.docService.selectedDocumentTypeForDash : (!this.fromDashbard && this.docService.selectedDocumentType) ? this.docService.selectedDocumentType : this.documentTypes[0].key;
        this.selectedDocumenttypeIdChange.emit(key);
        // this.selectedDocumentType = DocumentTypes.Opportunities;
        // this.selectedDocumentTypeForDash = DocumentTypes.Quotes;
      });
    });
  }

  checkDocPermissions(webTrackUser, permission): boolean {
    if (webTrackUser) {
      let item = webTrackUser.rights.find(r => r.name == permission);
      return item ? true : false;
    }
    return false;
  }
}
